import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';
import Filter, { IFilterInstance } from '@/pages/intelligence/components/Filter';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import useFilterUseHook from '@/pages/intelligence/hooks/useFilterUseHook';
import { formatFilterSaveValue } from '@intelligence/utils/filterUtils';
import * as FILTER_KEYS from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { FILTER_DEFAULT_INPUT_LIST, FILTER_DEFAULT_VALUE } from './_config';
import './index.scss';
import type { IBaseProps, IRegion } from '@/pages/intelligence/types/common';
import type { IMobileStoreRankMoreFilter, IStoreRankMoreCoreFetchParams } from '@/pages/intelligence/types/storeRank';
import { useDeepCompareEffect } from 'ahooks';

interface IMobileStoreRankMoreFilterProps extends IBaseProps {
  isOperate: boolean;
  initialCheckAllCountries: boolean;
  regionOptions: IRegion[] | null;
  filter: IMobileStoreRankMoreFilter | IStoreRankMoreCoreFetchParams;
  onInit: () => void;
  onConfirm: (payload: IMobileStoreRankMoreFilter) => void;
  onReset: () => void;
  rangeTimeComponentDefault: any;
  buttonLogConfig?: Record<string, any>;
  entityType?: string;
}

/** MgrMoreFilter 组件实例接口 */
export interface IMgrMoreFilterInstance {
  setValueAndConfirm: (partialValue: Record<string, any>) => void;
}

const DopuyinGamesMoreFilter: React.ForwardRefRenderFunction<IMgrMoreFilterInstance, IMobileStoreRankMoreFilterProps> = (props, ref) => {
  const {
    filter,
    onConfirm,
    rangeTimeComponentDefault,
    topchartName,
  } = props;

  const { setFilterExtend } = useFilterExtend({});
  const initialFormValue = (() => {
    const rangeTimeDefault = [filter?.start_date || '', filter?.end_date || ''];
    return {
      [FILTER_KEYS.RANGE_TIME]: {
        type: 'date',
        value: rangeTimeDefault,
      },
      [FILTER_KEYS.SINGLE_SOURCE_SELECT]: {
        extendFilterType: 'common',
        value: topchartName,
      },
    };
  })();

  const [formValue, setFormValue] = useState(initialFormValue);

  useDeepCompareEffect(() => {
    setFormValue(initialFormValue);
  }, [initialFormValue]);

  const formatFormValue = (values: any) => {
    const newFilterValues = formatFilterSaveValue({
      values,
      timeConfig: {
        // 天粒度单选1天
        needSameDay: true,
      },
    });
    return newFilterValues;
  };

  const { onFilterChange } = useFilterUseHook({
    defaultValue: FILTER_DEFAULT_VALUE,
    formValue,
    setFormValue,
    timeFilterValues: {
      type: 'daily',
      value: [filter?.start_date, filter?.end_date]
    },
    formatFormValue,
  });

  const handleFilterChange = (value: any, apiValue: any) => {
    setFormValue(value);

    const filterForm = {
      start_date: apiValue?.[FILTER_KEYS.RANGE_TIME]?.start_date,
      end_date: apiValue?.[FILTER_KEYS.RANGE_TIME]?.end_date,
      single_source_select: apiValue?.[FILTER_KEYS.SINGLE_SOURCE_SELECT]?.value,
    } as any;

    onConfirm?.(filterForm);
    setFilterExtend(apiValue);
  };

  const filterRef = useRef<IFilterInstance | null>(null);

  // 暴露 setValueAndConfirm 方法给父组件
  useImperativeHandle(ref, () => ({
    setValueAndConfirm: (partialValue: Record<string, any>) => {
      filterRef.current?.setValueAndConfirm(partialValue);
    },
  }));

  return (
    <Filter
      ref={filterRef}
      inputList={FILTER_DEFAULT_INPUT_LIST}
      defaultValue={{
        ...FILTER_DEFAULT_VALUE,
        [FILTER_KEYS.RANGE_TIME]: {
          type: 'date',
          value: rangeTimeComponentDefault?.date
        },
      }}
      value={formValue}
      onChange={onFilterChange}
      isHaveFilterSave={true}
      needConfirm={false} // 不需要确认按钮，选择后直接触发
      onConfirm={handleFilterChange}
      showButton={false}
    />
  );
};

export default forwardRef(DopuyinGamesMoreFilter);
